import React from "react";
import Plot from "../../../../utils/customPlotly";
import { isMobile } from "../../../../utils/deviceInfo";

const LinearNumericBarGraph = ({
  xScales,
  yScales,
  totalSumOfNumResponses,
  question,
}) => {
  // Data for the bar graph
  console.log({ xScales, yScales });

  const xValues = yScales;
  const yValues = xScales; // The raw data
  console.log({ x: xValues, y: yValues, totalSumOfNumResponses });

  // Get min/max values and labels from question config with fallbacks
  const minValue = question && question.linearNumericConfigs && question.linearNumericConfigs.min ? question.linearNumericConfigs.min : 1;
  const maxValue = question && question.linearNumericConfigs && question.linearNumericConfigs.max ? question.linearNumericConfigs.max : (yValues.length > 0 ? Math.max.apply(Math, yValues) : 10);
  const minLabel = question && question.linearNumericConfigs && question.linearNumericConfigs.minLabel && question.linearNumericConfigs.minLabel.length > 0 ? question.linearNumericConfigs.minLabel : "lowest";
  const maxLabel = question && question.linearNumericConfigs && question.linearNumericConfigs.maxLabel && question.linearNumericConfigs.maxLabel.length > 0 ? question.linearNumericConfigs.maxLabel : "highest";

  // Calculate percentages as whole numbers
  const percentages = xValues.map(
    (y) => Math.round((y / totalSumOfNumResponses) * 100)
  );

  const colors = [
    "#4E79A7",
    "#F28E2B",
    "#E15759",
    "#76B7B2",
    "#59A14F",
    "#EDC948",
    "#B07AA1",
    "#FF9DA7",
    "#9C755F",
    "#BAB0AC",
  ];

  // Create chart data with NO text labels (clean bars with just colors)
  const chartData = yValues.map((y, ind) => ({
    x: [xValues[ind]],
    y: [""],
    legendrank: ind + 1,
    name: `${y}`,
    orientation: "h",
    type: "bar",
    marker: {
      color: colors[ind] || "red",
      width: 1,
    },
    text: "", // No text on bar
    textposition: "none",
    hoverinfo: "skip", // No hover info
    showlegend: false, // Hide from legend
  }));

  console.log(chartData);

  return (
    <div>
      {/* Horizontal Bar Chart - Clean bars without labels */}
      <Plot
        data={chartData}
        layout={{
          barmode: "stack",
          xaxis: {
            showline: false,
            showgrid: false,
            zeroline: false,
            showticklabels: false,
          },
          yaxis: {
            dtick: 1,
            showticklabels: false,
          },
          margin: {
            t: 20,
            b: 20,
            l: 50,
            r: 50,
          },
          plot_bgcolor: "rgba(0,0,0,0)",
          paper_bgcolor: "rgba(0,0,0,0)",
          bargap: 0.5,
          showlegend: false,
        }}
        style={{ height: "80px", width: isMobile ? "320px" : "600px" }}
        config={{
          displayModeBar: false, // Hide mode bar completely
          displaylogo: false,
        }}
      />

      {/* Data Summary Table - Response Choices, Percentage, Responses */}
      <div style={{ marginTop: "16px", width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "12px",
            fontFamily: "Arial, sans-serif",
            border: "1px solid #ddd",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f5f5f5", borderBottom: "2px solid #333" }}>
              <th style={{ padding: "8px", textAlign: "left", verticalAlign: "middle", fontWeight: "bold", width: "55%" }}>
                {"Response Choices (" + minValue + " = " + minLabel + ", " + maxValue + " = " + maxLabel + ")"}
              </th>
              <th style={{ padding: "8px", textAlign: "left", verticalAlign: "middle", fontWeight: "bold", width: "20%" }}>
                Percentage
              </th>
              <th style={{ padding: "8px", textAlign: "left", verticalAlign: "middle", fontWeight: "bold", width: "25%" }}>
                Responses
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: maxValue - minValue + 1 }, (_, idx) => {
              const scaleValue = minValue + idx;
              const dataIndex = yValues.indexOf(scaleValue);
              const responseCount = dataIndex >= 0 ? xValues[dataIndex] : 0;
              const percentage = totalSumOfNumResponses > 0 ? Math.round((responseCount / totalSumOfNumResponses) * 100) : 0;

              return (
                <tr
                  key={scaleValue}
                  style={{
                    borderBottom: "1px solid #ddd",
                    backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa",
                  }}
                >
                  <td
                    style={{
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "12px",
                        height: "12px",
                        backgroundColor: colors[idx] || "#ccc",
                        borderRadius: "2px",
                        flexShrink: 0,
                      }}
                    ></span>
                    {scaleValue}
                  </td>
                  <td style={{ padding: "8px", textAlign: "left", fontWeight: "500" }}>
                    {isNaN(percentage) ? '' : `${percentage}%`}
                  </td>
                  <td style={{ padding: "8px", textAlign: "left" }}>
                    {responseCount}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LinearNumericBarGraph;
